import { useHistory, useLocation, useParams } from 'react-router-dom';
import './PublicDashboard.sass';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ScrollArea } from 'src/hci/common/ScrollArea/ScrollArea';
import classNames from 'classnames';
import Loading from 'src/hci/common/Loading/Loading';
import MissionReportList from 'src/components/Dashboard/ApplicationsArea/ReportingApp/MissionReporting/MissionReportList/MissionReportList';
import MissionReportPage from 'src/components/Dashboard/ApplicationsArea/ReportingApp/MissionReporting/MissionReportPage/MissionReportPage';
import { getPublicMissions } from 'src/components/Dashboard/ApplicationsArea/ReportingApp/ReportingAppSlice';

function PublicDashboard() {
  const location = useLocation();
  const missionId = new URLSearchParams(location.search).get('missionId');
  const apiKey = new URLSearchParams(window.location.search).get('x-api-key');
  const history = useHistory();
  const dispatch = useDispatch();
  const missions = useSelector(state => state.reportingApp.publicMissionsList?.missions);
  const selectedMission = missions?.find(mission => mission.id === missionId);

  const handleMissionSelection = (mission) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('missionId', mission.id);
    history.push(`/public-dashboard/?${searchParams.toString()}`);
  };

  const getMissions = () => {
    dispatch(getPublicMissions({ apiKey }));
  }

  useEffect(() => {
    if(apiKey) {
      getMissions();
    }
  }, [apiKey]);

  return (
    <div className="public-dashboard">
      <div className="mission-transparency">
        {missions ? (
          <div className="content">
            <div className={classNames("mission-list-container", {'side-view': !!missionId})}>
              <ScrollArea className="scroll-container">
                <MissionReportList
                  isPublic={true}
                  missions={missions} 
                  selectedMissionId={missionId} 
                  onMissionSelection={handleMissionSelection} 
                  sideView={!!missionId} 
                />
              </ScrollArea>
            </div>
            {missionId ? (
              <div className="report-page-container">
                <ScrollArea className="scroll-container">
                  <MissionReportPage isPublic={true} mission={selectedMission} />
                </ScrollArea>
              </div>
            ) : null}
          </div>
        ) : (
          <Loading message="Loading missions..." />
        )}
      </div>
    </div>
  )
}

export default PublicDashboard